import { render, staticRenderFns } from "./ModalDiscount.vue?vue&type=template&id=ffe91894"
import script from "./ModalDiscount.vue?vue&type=script&lang=js"
export * from "./ModalDiscount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports